var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { Scroll } from 'elements';
import theme from 'Theme';
class Modal extends Component {
    render() {
        const _a = this.props, { title, children, onClose } = _a, props = __rest(_a, ["title", "children", "onClose"]);
        const handleClose = onClose || (() => { });
        return (React.createElement(Wrapper, null,
            React.createElement(Backdrop, { onClick: handleClose }),
            React.createElement(Content, Object.assign({}, props),
                title && React.createElement(Title, null, title),
                React.createElement(Scroll, null, children))));
    }
}
export default Modal;
const Wrapper = cxs('div')({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10
});
const Backdrop = cxs('div')({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: Theme.color.backdrop,
    zIndex: 'inherit'
});
const Title = cxs('div')({
    color: 'white',
    backgroundColor: theme.color.secondary,
    fontSize: Theme.fontSize.big,
    textAlign: 'center',
    padding: Theme.size.space[1],
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
});
const Content = cxs('div')({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: 'auto',
    transform: 'translateY(-50%)',
    top: '50%',
    maxWidth: '90%',
    maxHeight: '80%',
    backgroundColor: Theme.color.background,
    zIndex: 'inherit',
    [mediaQueries.desktop]: {
        maxWidth: '600px'
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.tsx
// module id = 498
// module chunks = 0